// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { never } from "grpc-web-rx"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Slice from "../slices/timeline"
import * as Actions from "../actions"
import { grpc } from "../../../app/rpc/executor"
import { showSnackBar } from "../../snackbar/actions"
import { timesheetFieldClient } from "../../../app/rpc/client"
import {
  RemoveFavouriteTimesheetFieldOptionRequest,
  ListFavouriteTimesheetFieldOptionsResponse,
} from "../../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

type RemoveFavouriteTimesheetFieldOptionRpc = (request: RemoveFavouriteTimesheetFieldOptionRequest) => Observable<ListFavouriteTimesheetFieldOptionsResponse>

export const removeFavouriteTimesheetFieldOption = (removeFavouriteTimesheetFieldOptionRpc: RemoveFavouriteTimesheetFieldOptionRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.removeFavouriteTimesheetFieldOption.match),
      mergeMap((action) => of(action.payload)
        .pipe(
          mergeMap(removeFavouriteTimesheetFieldOptionRpc),
          map(response => ({ siteId: action.payload.getSiteId(), options: response.toObject().timesheetFieldOptionsList })),
          map(Slice.setFavouriteTimesheetFieldOptions),
          catchError(() => of(showSnackBar({
            message: t({
              id: "msg_remove_favourite_timesheet_field_option_failed",
              message: "Failed to unfavourite timesheet field option. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
            }),
            messageType: "ERROR",
          }))),
        )
      ),
    )

const removeFavouriteTimesheetFieldOptionRpc = (request: RemoveFavouriteTimesheetFieldOptionRequest): Observable<ListFavouriteTimesheetFieldOptionsResponse> =>
  grpc(() => timesheetFieldClient.removeFavouriteTimesheetFieldOption(request, null), never)

export default removeFavouriteTimesheetFieldOption(removeFavouriteTimesheetFieldOptionRpc)
